import { useMicrocopy } from "@lib/contentful/microcopy/MicrocopyContext";
import { Address, CommonCMS } from "@lib/constants/contentful";

export const useFormFieldsMicrocopy = () => {
    const { get: getMicrocopy } = useMicrocopy();

    const headers = {
        vatNumber: getMicrocopy(CommonCMS.page, Address.form.vatNumber),
        isCompany: getMicrocopy(CommonCMS.page, Address.form.isCompany),
        company: getMicrocopy(CommonCMS.page, Address.form.company),
        firstName: getMicrocopy(CommonCMS.page, Address.form.firstName),
        lastName: getMicrocopy(CommonCMS.page, Address.form.lastName),
        customerNumber: getMicrocopy(CommonCMS.page, Address.form.customerNumber),
        salutation: getMicrocopy(CommonCMS.page, Address.form.salutation),
        salutationPlaceholder: getMicrocopy(CommonCMS.page, Address.form.salutationPlaceholder),
        phoneticFirstName: getMicrocopy(CommonCMS.page, Address.form.phoneticFirstName),
        phoneticLastName: getMicrocopy(CommonCMS.page, Address.form.phoneticLastName),
        streetName: getMicrocopy(CommonCMS.page, Address.form.streetHouseNumber),
        addressLine2: getMicrocopy(CommonCMS.page, Address.form.additionalStreetName),
        requiredAdditionalStreetName: getMicrocopy(
            CommonCMS.page,
            Address.form.requiredAdditionalStreetName
        ),
        additionalAddressInfo: getMicrocopy(CommonCMS.page, Address.form.addAddressLine),
        additionalAddressTrigger: getMicrocopy(
            CommonCMS.page,
            Address.form.additionalAddressTrigger
        ),
        additionalAddressExpanded: getMicrocopy(
            CommonCMS.page,
            Address.form.additionalAddressExpanded
        ),
        streetHelpText: getMicrocopy(CommonCMS.page, Address.form.streetHelpText),
        additionalAddressHelpText: getMicrocopy(
            CommonCMS.page,
            Address.form.additionalAddressHelpText
        ),
        district: getMicrocopy(CommonCMS.page, Address.form.district),
        city: getMicrocopy(CommonCMS.page, Address.form.city),
        postalCode: getMicrocopy(CommonCMS.page, Address.form.zipCode),
        region: getMicrocopy(CommonCMS.page, Address.form.region),
        country: getMicrocopy(CommonCMS.page, Address.form.country),
        landmark: getMicrocopy(CommonCMS.page, Address.form.landmark),
        deliveryInstructions: getMicrocopy(CommonCMS.page, Address.form.deliveryInstructions),
        placeholderDropdown: getMicrocopy(CommonCMS.page, Address.form.placeholderDropdown),
        tooltipLabel: getMicrocopy(CommonCMS.page, Address.form.tooltipLabel),
        tooltipLabelStreetNumber: getMicrocopy(
            CommonCMS.page,
            Address.form.tooltipLabelStreetNumber
        ),
        parcelLockerHint: getMicrocopy(CommonCMS.page, Address.form.parcelLockerHint),
        tooltipValue: getMicrocopy(CommonCMS.page, Address.form.tooltipValue),
        noAddressesFound: getMicrocopy(CommonCMS.page, Address.form.noAddressesFound),
        errors: {
            zipCodeValid: getMicrocopy(CommonCMS.page, Address.error.zipCode),
            undeliverableAddress: getMicrocopy(CommonCMS.page, Address.error.undeliverableAddress),
            poBox: getMicrocopy(CommonCMS.page, Address.error.poBox),
            invalidPostalCodeCarrier: getMicrocopy(
                CommonCMS.page,
                Address.error.undeliverablePostalCodeCarrier
            ),
        },
        deliveryDate: getMicrocopy(CommonCMS.page, Address.form.deliveryDatePicker),
        deliveryTime: getMicrocopy(CommonCMS.page, Address.form.deliveryTimeSlot),
        timeslotOptions: {
            noPreference: getMicrocopy(CommonCMS.page, Address.form.noPreference),
            morning: getMicrocopy(CommonCMS.page, Address.form.morning),
            from14to16: getMicrocopy(CommonCMS.page, Address.form.from14to16),
            from16to18: getMicrocopy(CommonCMS.page, Address.form.from16to18),
            from18to20: getMicrocopy(CommonCMS.page, Address.form.from18to20),
            from19to21: getMicrocopy(CommonCMS.page, Address.form.from19to21),
        },
    };

    return { headers };
};
